export const regexError = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const regexErrorTest = (value, pattern) => {
    return pattern.test(value);
};

export const constructOptions = (arrayToMap, valueKey, labelKey) => {

    if (Array.isArray(arrayToMap)) {
        return arrayToMap?.map((item) => ({ value: item[valueKey], label: item[labelKey] }));
    }
}

export const getAuthToken = () => {
    try {
        const token = localStorage.getItem("token");
        return token;
    } catch (error) {
        return null;
    }
};

export const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatDateToDDMMYYYY = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return '';

    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
};

export const formatDateToYYYYMMDD = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return '';
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${year}-${month}-${day}`;
};


